import { VueWizard } from "@/vue-wizard";
import { Component } from "vue-property-decorator";
import FlowEditor from "@/app/components/flow/flow-editor/FlowEditor.vue";
import Swal from 'sweetalert2';
import {store} from "@/app/store";
import {TemplateCompanyInfo} from "@/app/interfaces";
import {PlanInfo} from "@/app/interfaces/plan-info";
import $ from "jquery";

@Component({
    name: "flow-manager",
    components: {
        FlowEditor
    }
})
export default class FlowManager extends VueWizard {

    async mounted() {
        this.$emit('showHelper', "Seleccione alguna de las plantillas de mensajería disponibles para el plan que escogió en el paso anterior")
        try {
            if(Object.keys(store.state.templateCompaniesInfo).length <= 0) {
                await this.$store.dispatch('loadTemplateCompaniesInfo');
            }
            if(store.state.flows.length === 0) {
                await this.$store.dispatch('loadPlanFlows');
            }
        } catch (error) {
            await this.launchSwalError(error);
        }
        $(() => ($('.not-allowed-template') as any).tooltip())
    }

    async reloadFlows(){
        try {
            await this.$store.dispatch('loadPlanFlows');
        } catch (error) {
            await this.launchSwalError(error);
        }
    }

    get templateCompaniesInfo(): {[key: string]: TemplateCompanyInfo} {
        return store.state.templateCompaniesInfo
    }

    get selectedTemplateCompanyId(): string | null {
        return store.state.templateCompanyId
    }

    get plansInfo(): PlanInfo[] {
        return store.state.plansInfo
    }

    get licensing(): string {
        return this.$store.state.formData.licensing
    }

    get selectedPlanInfo(): PlanInfo | undefined {
        return this.plansInfo.find(planInfo => planInfo.groupId === this.licensing)
    }

    isSelectedTemplateCompany(key: string) {
        return this.selectedTemplateCompanyId === key
    }

    selectedPlanAllowsCompany(companyId: string): boolean {
        return !!this.selectedPlanInfo
            && !!this.selectedPlanInfo.validCompanyTemplatesIds
            && Array.isArray(this.selectedPlanInfo.validCompanyTemplatesIds)
            && this.selectedPlanInfo.validCompanyTemplatesIds.length > 0
            && this.selectedPlanInfo.validCompanyTemplatesIds.includes(companyId);
    }

    async changeSelectedTemplate(id: string) {
        if(store.state.templateCompanyId !== id) {
            this.$store.commit('setFlows', [])
        }
        this.$store.commit('setTemplateCompanyId', id);
        await this.$store.dispatch('loadPlanFlows');
    }

    finish() {
        this.$store.dispatch('finishRegister', this.$route.params.id)
            .then(() => this.$router.push({name : "register-thanks"}))
            .catch(async (err) => {
                await Swal.fire({
                    title: "Error al registrar!",
                    icon: "error",
                    heightAuto: false,
                    html: `El formulario no ha sido enviado, razón: <b>${err.response.data.message}</b>`,
                    showCloseButton: true,
                    showCancelButton: false,
                    focusConfirm: false,
                });
            });
    }

    async launchSwalError(message: string) {
        await Swal.fire('Error', message, 'error')
            .then(async () => await this.$router.push({ name: "pre-register" }))
    }

}